import {Enumeration} from '@hit/base/src/models/data/enumeration';

export const RESOURCE_CATEGORIES = {
  LABOUR: '1062440d-534f-46d9-8176-fd9582ae6202',
  MATERIAL: '232a8533-6549-4d32-acc4-ce4d974d7f53',
  MACHINE: '31df80bd-c1b0-4636-9a66-ef2f2ff8a7a2',
  CONSUMABLE: '4c0f3477-bc97-42c3-9b09-3ddc582539ac',
  SUBCONTRACTOR: '5af4ec06-d4c3-41d2-b50d-650ab2235e07',
};

export class HitOnlineEnums extends Enumeration {
  static JOURNAL_TYPE = [
    {id: 'SALE', key: 'hit-app.hit-journal-type.sale'},
    {id: 'PURCHASE', key: 'hit-app.hit-journal-type.purchase'},
    {id: 'FINANCIAL', key: 'hit-app.hit-journal-type.financial'},
    {id: 'GENERAL', key: 'hit-app.hit-journal-type.general'},
  ];

  static TRANSACTION_TYPE = [
    {id: 'GENERAL', key: 'hit-app.hit-transaction-type.general'},
    {id: 'INVOICE', key: 'hit-app.hit-transaction-type.invoice'},
    {id: 'CREDITNOTE', key: 'hit-app.hit-transaction-type.creditnote'},
    {id: 'FINANCIAL', key: 'hit-app.hit-transaction-type.financial'},
  ];

  static ACTION_STATUS = [
    {id: 'OPENED', key: 'hit-app.hit-action-status.opened'},
    {id: 'ASSIGNED', key: 'hit-app.hit-action-status.assigned'},
    {id: 'CLOSED', key: 'hit-app.hit-action-status.closed'},
  ];

  static ACTION_OPERATION = [
    {id: 'CREATE', key: 'hit-app.hit-action-operation.create'},
    {id: 'START', key: 'hit-app.hit-action-operation.start'},
    {id: 'STOP', key: 'hit-app.hit-action-operation.stop'},
    {id: 'CLOSE', key: 'hit-app.hit-action-operation.close'},
    {id: 'MESSAGE', key: 'hit-app.hit-action-operation.message'},
    {id: 'REMINDER', key: 'hit-app.hit-action-operation.reminder'},
    {id: 'ASSIGN', key: 'hit-app.hit-action-operation.assign'},
    {id: 'UNASSIGN', key: 'hit-app.hit-action-operation.unassign'},
    {id: 'PAUSE', key: 'hit-app.hit-action-operation.pause'},
    {id: 'RENAME', key: 'hit-app.hit-action-operation.rename'},
    {id: 'ADD_TAG', key: 'hit-app.hit-action-operation.add-tag'},
    {id: 'REMOVE_TAG', key: 'hit-app.hit-action-operation.remove-tag'},
    {id: 'MERGE', key: 'hit-app.hit-action-operation.merge'},
    {id: 'REOPEN', key: 'hit-app.hit-action-operation.reopen'},
    {
      id: 'CHANGE_DUE_DATE',
      key: 'hit-app.hit-action-operation.change-due-date',
    },
    {
      id: 'CHANGE_ASSIGNEE',
      key: 'hit-app.hit-action-operation.change-assignee',
    },
    {
      id: 'BILLED',
      key: 'hit-app.hit-action-operation.billed',
    },
  ];

  static QM_DOCUMENT_HISTORY_OPERATION = [
    {id: 'DOWNLOAD', key: 'hit-app.common.download'},
  ];

  static UNIT_CATEGORY = [
    {id: 'quantity', key: 'hit-app.hit-unit-category.quantity'},
    {id: 'length', key: 'hit-app.hit-unit-category.length'},
    {id: 'area', key: 'hit-app.hit-unit-category.area'},
    {id: 'volume', key: 'hit-app.hit-unit-category.volume'},
    {id: 'mass', key: 'hit-app.hit-unit-category.mass'},
    {id: 'time', key: 'hit-app.hit-unit-category.time'},
    {id: 'power', key: 'hit-app.hit-unit-category.power'},
  ];

  static GENDER = [
    {id: 'MALE', key: 'hit-app.hit-gender.male'},
    {id: 'FEMALE', key: 'hit-app.hit-gender.female'},
    {id: 'NOT_SELECTED', key: 'hit-app.hit-gender.not-selected'},
    {id: 'NOT_SPECIFIED', key: 'hit-app.hit-gender.not-specified'},
    {id: 'OTHER', key: 'hit-app.hit-gender.other'},
  ];

  static PROJECT_PART_STATUS = [
    {
      id: 'QUOTATION_CREATED',
      key: 'hit-app.hit-project-part-status.quotation-created',
    },
    {
      id: 'QUOTATION_IGNORED',
      key: 'hit-app.hit-project-part-status.quotation-ignored',
    },
    {
      id: 'QUOTATION_IN_PROGRESS',
      key: 'hit-app.hit-project-part-status.quotation-in-progress',
    },
    {
      id: 'QUOTATION_MILESTONE',
      key: 'hit-app.hit-project-part-status.quotation-milestone',
    },
    {
      id: 'QUOTATION_SENT',
      key: 'hit-app.hit-project-part-status.quotation-sent',
    },
    {
      id: 'QUOTATION_ACCEPTED',
      key: 'hit-app.hit-project-part-status.quotation-accepted',
    },
    {
      id: 'QUOTATION_REFUSED',
      key: 'hit-app.hit-project-part-status.quotation-refused',
    },
    {
      id: 'QUOTATION_CANCELLED',
      key: 'hit-app.hit-project-part-status.quotation-cancelled',
    },
    {id: 'WORK_CREATED', key: 'hit-app.hit-project-part-status.work-created'},
    {
      id: 'WORK_TO_SCHEDULE',
      key: 'hit-app.hit-project-part-status.work-to-schedule',
    },
    {
      id: 'WORK_IN_PROGRESS',
      key: 'hit-app.hit-project-part-status.work-in-progress',
    },
    {
      id: 'WORK_MILESTONE',
      key: 'hit-app.hit-project-part-status.work-milestone',
    },
    {
      id: 'WORK_COMPLETED',
      key: 'hit-app.hit-project-part-status.work-completed',
    },
    {
      id: 'WORK_FINAL_INVOICE',
      key: 'hit-app.hit-project-part-status.work-final-invoice',
    },
    {id: 'WORK_ACCEPTED', key: 'hit-app.hit-project-part-status.work-accepted'},
  ];

  static PURCHASE_DOCUMENT_TYPE = [
    {
      id: 'PURCHASE_ORDER',
      key: 'hit-app.hit-purchase-document-type.purchase-order',
    },
    {
      id: 'PRICE_REQUEST',
      key: 'hit-app.hit-purchase-document-type.price-request',
    },
    {
      id: 'RATE_CONTRACT',
      key: 'hit-app.hit-purchase-document-type.rate-contract',
    },
    {
      id: 'PURCHASE_REQUIREMENT',
      key: 'hit-app.hit-purchase-document-type.purchase-requirement',
    },
    {
      id: 'WORK_ORDER',
      key: 'hit-app.hit-purchase-document-type.last-work-order',
    },
  ];

  static PURCHASE_STATUS = [
    {
      id: 'PARTIALLY_DELIVERED',
      key: 'hit-app.hit-purchase-status.partially-delivered',
    },
    {
      id: 'DELIVERY_COMPLETED',
      key: 'hit-app.hit-purchase-status.delivery-completed',
    },
  ];

  static ITEM_TYPE = [
    {
      id: 'TITLE',
      key: 'title',
    },
    {
      id: 'COMMENT',
      key: 'comment',
    },
    {
      id: 'ITEM',
      key: 'item',
    },
    {
      id: 'RESOURCE',
      key: 'resource',
    },
    {
      id: 'ITEM_GROUP',
      key: 'hit-app.hit-resource-type.item-group',
    },
  ];

  static RESOURCE_TYPE = [
    {
      id: 'TITLE',
      key: 'hit-app.hit-resource-type.title',
    },
    {
      id: 'RESOURCE',
      key: 'hit-app.hit-resource-type.resource',
    },
    {
      id: 'ITEM',
      key: 'hit-app.hit-resource-type.item',
    },
  ];

  static TECHNICAL_SPECIFICATION_TYPE = [
    {
      id: 'CURRENT',
      key: 'hit-app.hit-technical-specification-type.current',
    },
    {
      id: 'OLD',
      key: 'hit-app.hit-technical-specification-type.old',
    },
  ];

  static PROJECT_PART_SPEC_SHEET_HISTORY_STATUS = [
    {
      id: 'IN_PROGRESS',
      key: 'hit-app.hit-project-part-spec-sheet-history-status.in-progress',
    },
    {
      id: 'PENDING',
      key: 'hit-app.hit-project-part-spec-sheet-history-status.pending',
    },
    {
      id: 'VALIDATED',
      key: 'hit-app.hit-project-part-spec-sheet-history-status.validated',
    },
    {
      id: 'MISSING',
      key: 'hit-app.hit-project-part-spec-sheet-history-status.missing',
    },
    {
      id: 'NOT_REQUIRED',
      key: 'hit-app.hit-project-part-spec-sheet-history-status.not-required',
    },
  ];

  static ACTIVITY_TARGET = [
    {id: 'PROJECT_PART', key: 'hit-base.common.project-part'},
    {id: 'EQUIPMENT', key: 'hit-base.common.equipment'},
  ];

  static COST_TYPE = [
    {id: 'STAFF_HOUR', key: 'hit-app.staff.staff-hours'},
    {id: 'EQUIPMENT_HOUR', key: 'hit-app.equipment.equipment-hours'},
    {id: 'COST', key: 'hit-app.common.costs'},
    {id: 'PURCHASE_TRANSACTION', key: 'hit-base.common.transaction'},
    {id: 'DELIVERY_NOTE', key: 'hit-app.common.delivery-note'},
    {id: 'STOCK_MOVEMENT', key: 'hit-app.stock.stock-out'},
  ];

  static ACCOUNT_TYPE = [
    {id: 'TITLE', key: 'hit-app.hit-general-account-type.title'},
    {id: 'ASSET', key: 'hit-app.hit-general-account-type.asset'},
    {id: 'LIABILITY', key: 'hit-app.hit-general-account-type.liability'},
    {id: 'COST', key: 'hit-app.hit-general-account-type.cost'},
    {id: 'REVENUE', key: 'hit-app.hit-general-account-type.revenue'},
  ];

  static QUANTITY_TYPE = [
    {id: 'UNIT_QUANTITY', key: 'hit-app.hit-quantity-type.unit-quantity'},
    {id: 'TOTAL_QUANTITY', key: 'hit-app.hit-quantity-type.total-quantity'},
    {id: 'UNIT_EXPRESSION', key: 'hit-app.hit-quantity-type.unit-expression'},
    {id: 'TOTAL_EXPRESSION', key: 'hit-app.hit-quantity-type.total-expression'},
  ];

  static CONFIG_DATATYPE = [
    {id: 'JSON', key: 'hit-app.configuration.json'},
    {id: 'VARCHAR', key: 'hit-app.configuration.varchar'},
    {id: 'FLOAT', key: 'hit-app.configuration.number'},
    {id: 'DECIMAL', key: 'hit-app.configuration.decimal'},
    {id: 'DATE', key: 'hit-app.configuration.date'},
    {id: 'BOOLEAN', key: 'hit-app.configuration.boolean'},
    {id: 'INT', key: 'hit-app.configuration.int'},
  ];

  static HIT_BILLING_TYPE = [
    {id: 'BILLING_LUMP_SUM', key: 'hit-app.hit-billing-type.billing-lump-sum'},
    {id: 'BILLING_COSTS', key: 'hit-app.hit-billing-type.billing-costs'},
  ];

  static HIT_CONTRACT_STATUS = [
    {id: 'CONTRACT_ACTIVE', key: 'hit-app.hit-contract-status.active'},
    {id: 'CONTRACT_INACTIVE', key: 'hit-app.hit-contract-status.inactive'},
  ];

  static HIT_OPERATION_STATUS = [
    {id: 'OPEN', key: 'hit-app.hit-operation-status.pending'},
    {id: 'SUCCESS', key: 'hit-app.hit-operation-status.success'},
    {id: 'ERROR', key: 'hit-app.hit-operation-status.error'},
  ];

  static HIT_OPERATION_TYPE = [
    {id: 'REGISTER', key: 'hit-app.hit-operation-type.register'},
    {id: 'CANCEL', key: 'hit-app.hit-operation-type.cancel'},
  ];

  static HIT_NSSO_HISTORY_SOURCE = [
    {id: 'PLANNING', key: 'hit-app.hit-nsso-history-source.planning'},
    {id: 'MANUAL', key: 'hit-app.hit-nsso-history-source.manual'},
    {id: 'TRACKING', key: 'hit-app.hit-nsso-history-source.tracking'},
    {id: 'API', key: 'hit-app.hit-nsso-history-source.api'},
  ];

  static STAFF_COMPENSATION_SOURCE = [
    {id: 'MOBILE', key: 'hit-app.staff.hour-source-mobile'},
    {id: 'OFFICE', key: 'hit-app.staff.compensation-source-office'},
    {id: 'FORM', key: 'hit-app.staff.compensation-source-form'},
  ];

  static RESOURCE_CLASSIFICATION = [
    {id: 'TITLE', key: 'hit-app.hit-general-account-type.title'},
    {id: 'HSN', key: 'hit-app.hit-resource-classification.hsn'},
    {id: 'SAC', key: 'hit-app.hit-resource-classification.sac'},
  ];

  static TRANSACTION_STATUS = [
    {
      id: 'DOCUMENT_CREATED',
      key: 'hit-app.hit-transaction-status.document-created',
    },
    {
      id: 'DOCUMENT_REOPENED',
      key: 'hit-app.hit-transaction-status.document-reopened',
    },
    {
      id: 'DOCUMENT_TRANSACTED',
      key: 'hit-app.hit-transaction-status.document-transacted',
    },
    {id: 'DOCUMENT_SENT', key: 'hit-app.hit-transaction-status.document-sent'},
    {
      id: 'DOCUMENT_ACCEPTED',
      key: 'hit-app.hit-transaction-status.document-accepted',
    },
    {
      id: 'DOCUMENT_REFUSED',
      key: 'hit-app.hit-transaction-status.document-refused',
    },
    {
      id: 'DOCUMENT_DISPUTE_STARTED',
      key: 'hit-app.hit-transaction-status.document-dispute-started',
    },
    {
      id: 'DOCUMENT_DISPUTE_RESOLVED',
      key: 'hit-app.hit-transaction-status.document-dispute-resolved',
    },
    {id: 'DOCUMENT_DUE', key: 'hit-app.hit-transaction-status.document-due'},
    {
      id: 'REMINDER_1',
      key: 'hit-app.hit-transaction-status.reminder-1',
    },
    {
      id: 'REMINDER_2',
      key: 'hit-app.hit-transaction-status.reminder-2',
    },
    {
      id: 'REMINDER_3',
      key: 'hit-app.hit-transaction-status.reminder-3',
    },
    {
      id: 'REMINDER_4',
      key: 'hit-app.hit-transaction-status.reminder-4',
    },
    {
      id: 'REMINDER_5',
      key: 'hit-app.hit-transaction-status.reminder-5',
    },
    {
      id: 'REMINDER_6',
      key: 'hit-app.hit-transaction-status.reminder-6',
    },
    {
      id: 'REMINDER_7',
      key: 'hit-app.hit-transaction-status.reminder-7',
    },
    {
      id: 'REMINDER_8',
      key: 'hit-app.hit-transaction-status.reminder-8',
    },
    {
      id: 'REMINDER_9',
      key: 'hit-app.hit-transaction-status.reminder-9',
    },
    {id: 'DOCUMENT_PAID', key: 'hit-app.hit-transaction-status.document-paid'},
    {
      id: 'DOCUMENT_CLOSED',
      key: 'hit-app.hit-transaction-status.document-closed',
    },
  ];
  static PROCUREMENT_STATUS = [
    {
      id: 'PURCHASE_ORDER_IN_PROGRESS',
      key: 'hit-app.hit-procurement-status.purchase-order-in-progress',
    },
    {
      id: 'PURCHASE_ORDER_SENT',
      key: 'hit-app.hit-procurement-status.purchase-order-sent',
    },
    {
      id: 'PARTIALLY_DELIVERED',
      key: 'hit-app.hit-procurement-status.partially-delivered',
    },
    {
      id: 'DELIVERY_COMPLETED',
      key: 'hit-app.hit-procurement-status.delivery-completed',
    },
    {
      id: 'PRICE_REQUEST_IN_PROGRESS',
      key: 'hit-app.hit-procurement-status.price-request-in-progress',
    },
    {
      id: 'PRICE_REQUEST_SENT',
      key: 'hit-app.hit-procurement-status.price-request-sent',
    },
    {
      id: 'PRICE_REQUEST_COMPLETED',
      key: 'hit-app.hit-procurement-status.price-request-completed',
    },
    {
      id: 'RATE_CONTRACT_IN_PROGRESS',
      key: 'hit-app.hit-procurement-status.rate-contract-in-progress',
    },
    {
      id: 'RATE_CONTRACT_ACTIVE',
      key: 'hit-app.hit-procurement-status.rate-contract-active',
    },
    {
      id: 'RATE_CONTRACT_EXPIRED',
      key: 'hit-app.hit-procurement-status.rate-contract-expired',
    },
    {
      id: 'PURCHASE_REQUIREMENT_IN_PROGRESS',
      key: 'hit-app.hit-procurement-status.purchase-requirement-in-progress',
    },
    {
      id: 'PURCHASE_REQUIREMENT_APPROVED_FOR_PURCHASE',
      key: 'hit-app.hit-procurement-status.purchase-requirement-approved-for-purchase',
    },
    {
      id: 'PURCHASE_REQUIREMENT_COMPLETED',
      key: 'hit-app.hit-procurement-status.purchase-requirement-completed',
    },
    {
      id: 'WORK_ORDER_IN_PROGRESS',
      key: 'hit-app.hit-procurement-status.work-order-in-progress',
    },
    {
      id: 'WORK_ORDER_CONFIRMED',
      key: 'hit-app.hit-procurement-status.work-order-confirmed',
    },
    {
      id: 'WORK_IN_PROGRESS',
      key: 'hit-app.hit-procurement-status.work-in-progress',
    },
    {
      id: 'WORK_ORDER_COMPLETED',
      key: 'hit-app.hit-procurement-status.work-order-completed',
    },
  ];

  static RESPONSE_STATUS = [
    {
      id: 'IN_PROGRESS',
      key: 'hit-app.hit-response-status.in-progress',
    },
    {
      id: 'SENT',
      key: 'hit-app.hit-response-status.sent',
    },
    {
      id: 'WILL_RESPOND',
      key: 'hit-app.hit-response-status.will-respond',
    },
    {
      id: 'IN_FOLLOW_UP',
      key: 'hit-app.hit-response-status.in-follow-up',
    },
    {
      id: 'WILL_NOT_RESPOND',
      key: 'hit-app.hit-response-status.will-not-respond',
    },
    {
      id: 'ANSWERED',
      key: 'hit-app.hit-response-status.answered',
    },
  ];

  static PROJECT_PART_BILL_STATUS = [
    {
      id: 'BILL_IN_PROGRESS',
      key: 'hit-app.project-part-bill.bill-in-progress',
    },
    {id: 'BILL_SENT', key: 'hit-app.project-part-bill.bill-sent'},
    {
      id: 'BILL_ACCEPTED',
      key: 'hit-app.project-part-bill.bill-accepted',
    },
    {
      id: 'BILL_REFUSED',
      key: 'hit-app.project-part-bill.bill-refused',
    },
    {
      id: 'BILL_DEBT_LETTER_CREATED',
      key: 'hit-app.project-part-bill.bill-debt-letter-created',
    },
    {
      id: 'BILL_DEBT_LETTER_SENT',
      key: 'hit-app.project-part-bill.bill-debt-letter-sent',
    },
    {
      id: 'BILL_INVOICED',
      key: 'hit-app.project-part-bill.bill-invoiced',
    },
  ];

  static ALERT_TYPE = [
    {id: 'TRACKING_MAX_SPEED', key: 'hit-app.alert.type.tracking-max-speed'},
    {
      id: 'TRACKING_MOVEMENT_DETECTION',
      key: 'hit-app.alert.type.tracking-movement-detection',
    },
    {
      id: 'TRACKING_BATTERY_LOW',
      key: 'hit-app.alert.type.tracking-battery-low',
    },
    {
      id: 'TRACKING_UNKNOWN_BADGE',
      key: 'hit-app.alert.type.tracking-unknown-badge',
    },
    {id: 'TRACKING_LEAVE_POI', key: 'hit-app.alert.type.tracking-leave-poi'},
    {id: 'TRACKING_ENTER_POI', key: 'hit-app.alert.type.tracking-enter-poi'},
  ];
}
